import React from 'react';
import { GlassCard } from '../shared/GlassCard';
import { GradientText } from '../shared/GradientText';
import { FadeIn, SlideIn } from '../shared/MotionWrapper';
import { GAMES } from '../../data/games';

function SummitSpotlightSection() {
  const summit = GAMES.summit;

  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-dark-secondary" />
      <div className="absolute inset-0 lightning-bg opacity-40" />
      <div className="absolute top-0 left-0 right-0 h-px glow-separator" />

      <div className="container-premium relative z-10">
        <GlassCard variant="premium" className="p-8 md:p-12 relative overflow-hidden">
          <div
            className="absolute inset-0 bg-contain bg-center bg-no-repeat pointer-events-none"
            style={{
              backgroundImage: 'url(/images/background-summit.png)',
              opacity: 0.15,
            }}
          />
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <FadeIn direction="left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-hash-gold/10 border border-hash-gold/20 mb-6">
                <img src="/images/icon-crown.svg" alt="Crown" className="w-4 h-4" />
                <span className="text-hash-gold text-sm font-semibold">Flagship Event</span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
                The <GradientText variant="hash" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Summit</GradientText>{' '}
                <GradientText variant="medora" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Draw</GradientText>
              </h2>

              <p className="text-gray-400 text-lg mb-6 leading-relaxed">
                The ultimate community event. A massive prize pool with three tiers of winning
                opportunities. Entry at just <span className="text-hash-gold font-bold">5 USD</span>.
              </p>

              <div className="flex items-center gap-4 mb-8">
                <div className="text-center">
                  <div className="text-3xl sm:text-4xl font-bold text-hash-gold drop-shadow-[0_0_15px_rgba(238,212,91,0.5)]">
                    {summit.grandPrizePool?.toLocaleString()} USD
                  </div>
                  <div className="text-gray-500 text-sm">Grand Prize Pool</div>
                </div>
              </div>

              <span
                className="inline-flex items-center gap-2 px-8 py-3 rounded-xl border border-gray-600/40 bg-gray-800/60 text-gray-500 text-sm font-semibold cursor-not-allowed"
                title="Summit Draw registration is not open yet"
              >
                <img src="/images/icon-ticket.svg" alt="" className="w-5 h-5 opacity-40" />
                Coming soon
              </span>
            </FadeIn>

            <div className="space-y-4">
              {summit.tiers?.map((tier, index) => (
                <SlideIn key={index} from="right" delay={index * 0.15}>
                  <div className="game-card-border p-5 rounded-xl">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center gap-3">
                        {index === 0 && <img src="/images/icon-apex.png" alt="" className="w-10 h-10 object-contain" />}
                        {index === 1 && <img src="/images/icon-vault.png" alt="" className="w-10 h-10 object-contain" />}
                        {index === 2 && <img src="/images/icon-strike.png" alt="" className="w-10 h-10 object-contain" />}
                        <div>
                          <h4 className="text-white font-bold">{tier.name}</h4>
                          <p className="text-gray-500 text-xs">{tier.neighborCount.toLocaleString()} neighbors @ {tier.neighborPrize} USD</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-hash-gold font-bold text-lg">{tier.prize.toLocaleString()} USD</div>
                        <div className="text-gray-500 text-xs">Grand Prize</div>
                      </div>
                    </div>
                    <div className="flex justify-between text-sm text-gray-400">
                      <span>Total Pool: <span className="text-white font-semibold">{tier.totalPool.toLocaleString()} USD</span></span>
                    </div>
                  </div>
                </SlideIn>
              ))}
            </div>
          </div>
        </GlassCard>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px glow-separator" />
    </section>
  );
}

export default SummitSpotlightSection;
